import { z } from "zod";
import { RequestParameterSectionDtoSchema } from "./RequestParameterSectionDto";
import { RequestFieldDtoSchema } from "./RequestFieldDto";

export const SectionOrFieldDtoSchema = z.object({
    order: z.number(),
    section: z.lazy(() => RequestParameterSectionDtoSchema.nullish()),
    field: RequestFieldDtoSchema.nullish(),
});

export type SectionOrFieldDto = z.infer<typeof SectionOrFieldDtoSchema>;
